import styled from "@emotion/styled";
import Page from 'components/layout/Page';

import { ContextContainer } from 'components/ui';
import { BigText } from 'components/ui';
import { Button }  from "components/ui"

const Elem:React.FC<any> = () => {
  return (
    <Page disable={false}>
      <Container>
        <ContextContainer>
          <InfoBigText>쿠폰</InfoBigText>
        </ContextContainer>
        <ContextContainer>
        <ContextContainer className="Title">
            <CouponInputBox
              placeholder="쿠폰 번호를 입력하세요"
            >
            </CouponInputBox>
            <ButtonWrapper>
              <ModifyButton 
                layoutVariant='contained'
                variant='default'
                size='large'
                expand
              > 
                등록
              </ModifyButton>
            </ButtonWrapper>
          </ContextContainer>
        </ContextContainer>
      </Container>  
    </Page>
  );
};

export default Elem;

const Container = styled.div`
  width: 430px;
  height: 700px;
  min-height: 0vh;


  display: flex;
  flex-direction: column;
`
const InfoBigText = styled(BigText)`
  font-size: 23px;
  font-weight: 700;
  margin-top: 16px;
`
const ButtonWrapper = styled.div`
  width: 147px;
  height: 100%;
`;

const ModifyButton =styled(Button)`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
`;

const CouponInputBox =styled.input`
  width: 270px;
  background-color: var(--light-grey);
  padding-left: 20px;

  &::placeholder {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    color: #B3B3B3;
  }
`